import "@babel/polyfill";
import $ from 'jquery';
import loader from './__modules/loader';
import shopInfo from "./__modules/shop-info";
import slider from './__modules/slider';
import about from './__modules/about';
import accordion from './__modules/accordion';
import serviceIntro from './__modules/serviceIntro';
import serviceInfo from './__modules/serviceInfo';
import AOS from 'aos';

document.addEventListener('DOMContentLoaded', () => {
	if($(".loader").length) {
		
		// Loader
		loader();

		setTimeout(() => {
			// Slider Init
			slider();
		}, 500);
	}

	// Shop Info
	if($(".shop-info").length) {
		shopInfo();
	}

	// About text splits
	if($(".about-main").length) {
		about();
	}

	// Service intro text splits
	if($(".service-intro").length) {
		serviceIntro();
	}

	// Service info text splits
	if($(".service-info").length) {
		serviceInfo();
	}

	// Menubar trigger click
	$(".menubar").on("click", (e) => {
		e.preventDefault();

		$(".menubar").toggleClass("active");
		$(".menu-wrapper").slideToggle();
	});

	// Scroll to section on click explore
	$(".service-exploring a").on("click", (e) => {
		e.preventDefault();

		$("html, body").animate({
			scrollTop: $(e.target).parent().next().offset().top - 140
		}, 1000);
	});

	// Scroll to section on shop main text click
	$(".shop-main--text a").on("click", (e) => {
		e.preventDefault();

		$("html, body").animate({
			scrollTop: $(".shop-info").offset().top - 140
		}, 1000);
	});

	// AOS Init
    AOS.init({
		startEvent: 'DOMContentLoaded',
		offset: 0,
		delay: 0,
		duration: 400, 
		easing: 'ease',
		once: true,
		animatedClassName: 'animated'
	});

	wrapMenu();
});

window.addEventListener('load', () => {
	// Accordion event click
	if($(".accordion").length) {
		accordion();
	}
});

window.addEventListener('resize', () => {
	wrapMenu();
});

// Make header fixed on scroll
window.addEventListener('scroll', () => {
	if($(window).scrollTop() > 0) {
		$(".header").addClass("active");
	} else {
		$(".header").removeClass("active");
	}
});

function wrapMenu() {
	if($(window).width() < 992) {
		$(".menu").wrapAll("<div class='menu-wrapper' />")
	} else {
		$('.menu-wrapper').contents().unwrap(); 
	}
}